import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from '../ui';
import styles from './AuthRequiredModal.module.css';

const AuthRequiredModal = ({ isOpen, onClose, message }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate('/auth');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Acceso necesario" size="sm">
      <div className={styles.content}>
        <p className={styles.message}>
          {message ||
            'Para acceder a esta sección necesitas iniciar sesión con tu número y PIN.'}
        </p>
        <Button variant="primary" fullWidth onClick={handleLogin}>
          Iniciar sesión
        </Button>
        <Button variant="ghost" fullWidth onClick={onClose}>
          Cancelar
        </Button>
      </div>
    </Modal>
  );
};

export default AuthRequiredModal;
